export default "__VITE_ASSET__8d9364a0__"